// removed by extract-text-webpack-plugin
module.exports = {"NewSensor":"NewSensor--2xQpi"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Sensor/NewSensor.scss
// module id = 950
// module chunks = 1